// Client Layout - Dashboard layout for clients/parents
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const clientNavLinks = [
  { path: '/client/dashboard', label: 'Dashboard', icon: '🏠' },
  { path: '/client/bookings', label: 'My Bookings', icon: '📅' },
  { path: '/client/invoices', label: 'Invoices', icon: '💳' },
  { path: '/client/progress', label: 'Progress', icon: '📈' },
  { path: '/client/messages', label: 'Messages', icon: '💬' },
  { path: '/client/profile', label: 'Profile', icon: '👤' }
];

export default function ClientLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  
  return (
    <div className="min-h-screen bg-base-100">
      <div className="navbar bg-gradient-to-r from-primary to-secondary text-white shadow-lg">
        <div className="flex-1">
          <Link to="/client/dashboard" className="font-heading font-bold text-xl ml-4">My Dashboard</Link>
        </div>
        <div className="flex-none gap-4">
          <Link to="/" className="btn btn-ghost text-white">← Back to Site</Link>
          <div className="dropdown dropdown-end">
            <label tabIndex={0} className="btn btn-ghost btn-circle avatar placeholder">
              <div className="w-10 rounded-full bg-white/20">
                <span className="text-sm font-semibold">{user?.firstName[0]}{user?.lastName[0]}</span>
              </div>
            </label>
            <ul tabIndex={0} className="menu dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 text-base-content rounded-box w-52">
              <li><button onClick={logout}>Logout</button></li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col lg:flex-row gap-6">
          <aside className="w-full lg:w-64">
            <ul className="menu bg-base-200 rounded-lg p-2">
              {clientNavLinks.map(link => (
                <li key={link.path}>
                  <Link to={link.path} className={location.pathname === link.path ? 'active' : ''}>
                    <span>{link.icon}</span> {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </aside>
          <main className="flex-1"><Outlet /></main>
        </div>
      </div>
    </div>
  );
}